import React from 'react'

const DocumentPdf = () => {
    // const location = useLocation()
    // const history = useHistory()

    // const { selectedCards, companyName, nit } = location.state || {}

    // const currentDate = new Date();
    // const day = String(currentDate.getDate()).padStart(2, '0');
    // const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    // const year = currentDate.getFullYear();
    // const formattedDate = `${day}-${month}-${year}`;
    // const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))

    // return (
    //     <>
    //         <Button onClick={() => history.push('/gdv_home')}>Volver</Button>
    //         <PDFViewer style={styles.viewer}>
    //             <Document>
    //                 <Page style={styles.page}>
    //                     <View style={styles.header}>
    //                         <View style={styles.section}>
    //                             <View >
    //                                 <Image src={icon} style={styles.img} />
    //                             </View>
    //                         </View>
    //                         <View style={styles.titleHeader}>
    //                             <Text>Gestión de Desarrollo Comercial</Text>
    //                         </View>
    //                     </View>
    //                     <View style={styles.infoContainer}>
    //                         <Text style={styles.titleInfo}>Plan detallado</Text>
    //                         <Text style={styles.txtInfo}>{companyName} NIT {nit}</Text>
    //                         <Text style={styles.txtInfo}>Consultor: {userInfo.nombre} {userInfo.apellido} </Text>
    //                         <Text style={styles.txtInfo}>Generado: {formattedDate}</Text>
    //                     </View>
    //                     <View style={styles.cardContainer}>
    //                         {selectedCards.map(card => (
    //                             <View style={styles.card}>
    //                                 <Text style={styles.txtContent}>Cluster: {clustersNames.find(cluster => cluster.id === card.cluster_id).name}</Text>
    //                                 <Text style={styles.txtContent}>Título: {card.titulo}</Text>
    //                                 <Text style={styles.txtContent}>Prioridad: {card.prioridad}</Text>
    //                                 <Text style={styles.txtContent}>Descripción: {card.texto}</Text>
    //                                 <Text style={styles.txtContent}>Beneficio:{card.valoracion}</Text>
    //                                 <Text style={styles.txtContent}>Inversion:{card.costo}</Text>
    //                                 <Text style={styles.txtContent}>Tiempo estimado retorno de la inversión: {card.finalizacion}</Text>
    //                             </View>
    //                         ))}
    //                     </View>
    //                     <View style={styles.footer}>
    //                         <View style={styles.cardFooter}>
    //                             <Text style={styles.txtContent}>Firmado el (día-mes-año)</Text>
    //                         </View>
    //                         <View style={styles.cardFooter}>
    //                             <Text style={styles.txtContent}>Nombre representante razón social</Text>
    //                         </View>
    //                         <View style={styles.cardFooter}>
    //                             <Text style={styles.txtContent}>Firma</Text>
    //                         </View>
    //                     </View>
    //                 </Page>
    //             </Document>
    //         </PDFViewer>
    //     </>
    // )
}

export { DocumentPdf }